import Icon from '../Icon';
import React from 'react';
import { useDispatch } from 'react-redux';
import { setLoginModalOpen } from '../../Actions/Login.action';
import clsx from 'clsx';

const LoginModalTrigger = () => {
  const dispatch = useDispatch();
  return (
    <button
      onClick={() => dispatch(setLoginModalOpen(true))}
      className="pointer px-2 py-3 lg:py-2"
    >
      <Icon
        className={clsx(
          'h-6 w-6 text-gray-700 transition ease-in-out group-[.is-light-theme]:text-white'
        )}
        name="user"
      />
    </button>
  );
};
export default LoginModalTrigger;
